export class CompraNFeEntradaPedidosElegiveisRequest {
  pesquisar?: string | null;
  idsCompra?: number[] | null;
  idsVinculoSubstituir: number[] = [];
  idsProduto?: number[] | null;
  /** Emitente da nota. Com ele ou com `idsProduto`, o pré-filtro é fornecedor OU produto. */
  idFornecedor?: number | null;
  pagina: number = 0;
  tamanhoPagina: number = 20;
}
